export default __webpack_public_path__ + "static/media/book.6fb1fec4.png";